// extracted by mini-css-extract-plugin
export var link = "BackLink-module--link--1dc58";